import React from 'react';
import { Link } from 'gatsby';
import BreadCrumbAdmin from '@assets/icons/admin-session/breadcrumb-admin';
import MenuButton from '@components/Header/components/menu-button';
import { useLocation } from '@reach/router';

import '../show-admin-session.css';
import '../../../components/Header/components/nav-links.css';
import { titleMap } from '@components/layouts/admin';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { themeSelector } from '@redux/selectors';
import { ThemeInterface } from '@redux/prop-types';

type NavbarProps = {
  userData: { name: string; access: string };
  fetchState?: { pending: boolean };
};

const BreadCrumbAdminItem = styled(Link)<{
  greaterThanOne: boolean;
  isLast: boolean;
}>`
  color: ${({ greaterThanOne, isLast }) =>
    greaterThanOne && isLast ? '#989898' : '#484848'};

  font-size: 14px;
  font-weight: 400;

  :hover {
    cursor: pointer;
    text-decoration: underline;
    color: ${({ greaterThanOne, isLast }) =>
      greaterThanOne && isLast ? '#989898' : '#484848'};
  }

  :active,
  :focus {
    color: ${({ greaterThanOne, isLast }) =>
      greaterThanOne && isLast ? '#989898' : '#484848'};
  }

  .dark & {
    color: rgba(255, 255, 255, 0.8);
  }
`;

const Navbar: React.FC<NavbarProps> = ({ userData, fetchState }) => {
  const location = useLocation();
  const pathnames = location.pathname
    .split('/')
    .filter(x => x)
    .slice(1);
  const searchParams = new URLSearchParams(location.search);
  const hasId = searchParams.has('id');

  const userFirstname = userData?.name?.split(' ')[0];

  const breadcrumbItems = pathnames.map((path, index) => {
    const isLast = index === pathnames.length - 1;
    const greaterThanOne = pathnames.length > 1;
    let translatedLabel = titleMap[path] || path;

    if (path === 'message-form') {
      translatedLabel = hasId ? 'Edição de mensagem' : 'Cadastro de mensagem';
    }

    if (path === 'class-groups-form-page') {
      translatedLabel = hasId ? 'Edição de turma' : 'Cadastro de turma';
    }

    return (
      <React.Fragment key={translatedLabel}>
        <BreadCrumbAdminItem
          greaterThanOne={greaterThanOne}
          isLast={isLast}
          to={`/admin/${pathnames.slice(0, index + 1).join('/')}`}
          onClick={isLast ? e => e.preventDefault() : undefined}
        >
          {translatedLabel}
        </BreadCrumbAdminItem>
        {!isLast && <span>&gt;</span>}
      </React.Fragment>
    );
  });

  return (
    <nav className='navbar'>
      <div className='breadcrumb-admin'>
        <BreadCrumbAdmin />
        {breadcrumbItems}
      </div>

      <div className='universal-nav-right'>
        <MenuButton
          username={userFirstname}
          userAccess={userData.access}
          fetchState={fetchState}
        />
      </div>
    </nav>
  );
};

const mapStateToProps = createSelector(
  themeSelector,
  (theme: ThemeInterface) => ({
    theme
  })
);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
